// Shared Asia/Kolkata (IST) date helpers.
//
// The delivery kitchen operates in India, so "today" for menu resolution must
// always be the calendar date in Asia/Kolkata regardless of the user's local
// timezone or SSR runtime (workers run in UTC).
//
// Do NOT use `new Date().toISOString().slice(0, 10)` for menu/date logic — it
// returns the UTC date, which drifts by up to 5h30m from IST and flips a day
// early during India's late evening.

const IST_FORMATTER = new Intl.DateTimeFormat("en-CA", {
  timeZone: "Asia/Kolkata",
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
});

/** Returns the current Asia/Kolkata date as `YYYY-MM-DD`. */
export function todayInIST(): string {
  // "en-CA" formats as YYYY-MM-DD.
  return IST_FORMATTER.format(new Date());
}

/** Returns the Asia/Kolkata date for a given instant as `YYYY-MM-DD`. */
export function toISTDate(instant: Date | number): string {
  return IST_FORMATTER.format(instant instanceof Date ? instant : new Date(instant));
}

const IST_DATE_LONG = new Intl.DateTimeFormat("en-IN", {
  timeZone: "Asia/Kolkata",
  day: "2-digit",
  month: "short",
  year: "numeric",
});

const IST_DATETIME_LONG = new Intl.DateTimeFormat("en-IN", {
  timeZone: "Asia/Kolkata",
  day: "2-digit",
  month: "short",
  year: "numeric",
  hour: "2-digit",
  minute: "2-digit",
  hour12: true,
});

/** Human-readable IST date, e.g. "28 Jul 2026". */
export function formatISTDate(value: string | Date | number | null | undefined): string {
  if (value === null || value === undefined || value === "") return "—";
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return "—";
  return IST_DATE_LONG.format(d);
}

/** Human-readable IST timestamp, e.g. "28 Jul 2026, 04:44 pm IST". */
export function formatISTDateTime(value: string | Date | number | null | undefined): string {
  if (value === null || value === undefined || value === "") return "—";
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return "—";
  return `${IST_DATETIME_LONG.format(d)} IST`;
}